module.exports = __webpack_public_path__ + "img/ltkbeauty-3x.7c61bfb.jpg";